import { useEffect, useState, } from "react";
import Grid from "@mui/material/Grid";
import { useNavigate } from "react-router-dom";
import { GridColDef } from "@mui/x-data-grid-pro";
import { TablePage } from "components/alove/TablePage";
import { getFullBrandsDO, getBrandsStatsDO } from "utils/brandsUtils";
// import { hasFeature } from "utils/settingsUtils";
import { StatsPanel } from "components/alove/StatsPanel";
// import { TwoSizeChip } from "components/alove/Chips";
import { formatDateTime, formatDate, daysFromNow } from "utils/globalsUtils";
const { useMaterialUIController } = require("context");
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { setCurrentBrand } from "context";
import { PageNumber } from "../../accessNumbers";
const DashboardNavbar = require("examples/Navbars/DashboardNavbar/index.js").default;
const MDInput = require("components/MDInput/index.js").default;

function ViewBrandsList() {
  const navigate = useNavigate();
  
  const [controller, dispatch] = useMaterialUIController();
  const { currentBrand, currentUser, currentRole } = controller;
  const [brands, setBrands] = useState(false);
  const [stats, setStats] = useState({

    endUsers: 0,
    activeUsers: 0,
    currentIntro: 0,
    currentInteractions: 0,
  });
  const [showPending, setShowPending] = useState(false);
  const isAdmin = currentRole.hasAccess(PageNumber.Brands);
  const columns: GridColDef<any>[] = [
    {
      headerName: "Brand",
      field: "name",
      flex: 1,
      // minWidth: 170,
      // renderCell: (params) => ,
    },
    { headerName: "End Users", field: "endUsers", flex: 1, align: "center" },
    { headerName: "Active Users", field: "activeUsers", flex: 1, align: "center" },
    { headerName: "Open Introductions", field: "currentIntro", flex: 1, align: "center" },
    { headerName: "Active Interactions", field: "currentInteractions", flex: 1, align: "center" },
    { headerName: "Open Tickets", field: "openTickets", flex: 1,  align: "center"},
    {
      headerName: "SLA fulfillment",
      field: "slaFulfillment",
      flex: 1,
      // minWidth: 170,
      valueFormatter: (v) => v ? `${daysFromNow(v)} days` : ""
    }
  ];

  useEffect(() => {
    getBrandsStatsDO().then((stats) => {
      setStats(stats);
    });
  }, []);

  const getBrands = async (filters: any, page: number) => {
    const realBrands: any = await getFullBrandsDO();
    return realBrands;
  };

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle="Brands" />
      <Grid container gap={1}>
        <TablePage
          title='Brands'
          table={{
            columns,
            loadNext: getBrands,
            lineClick: (row) => {
              setCurrentBrand(dispatch, row?.row);
               navigate(`/brands/${row?.row?.name}`)
            },
            pagination: isAdmin,
            // rowCount: stats.totalProfiles,
          }}
          filters={[]}
          stats={{
            title:"Brands Statistics",
            fields:[
              {
                title: "End Users",
                name: "endUsers",
              },
              {
                title: "Active Users",
                name: "activeUsers",
                color: "primary",
              },
              {
                title: "Open Introductions",
                name: "currentIntro",
              },
              {
                title: "Active Interactions",
                name: "currentInteractions",
                color: "primary",
              }
            ],
            stats:stats}
          }
        />
      </Grid>
    </DashboardLayout>
  );
}

export default ViewBrandsList;
